import { ApolloProvider } from "@apollo/client";
import { clientNeoAuth } from "@neonumy/api-clients";
import { NotificationProvider } from "@neonumy/neonumy-ui";
import { ConfigProvider } from "antd";
import type { Locale } from "antd/es/locale";
import en_GB from "antd/es/locale/en_GB";
import fr_FR from "antd/es/locale/fr_FR";
import i18n from "config/i18n/i18n";
import { routers } from "config/routes";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/fr";
import isBetween from "dayjs/plugin/isBetween";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import localeData from "dayjs/plugin/localeData";
import minMax from "dayjs/plugin/minMax";
import utc from "dayjs/plugin/utc";
import { I18nextProvider } from "react-i18next";
import { RouterProvider } from "react-router-dom";

import "@neonumy/neonumy-ui/lib/index.css";
import "resources/styles/main.less";

const CONFIG_TRANSLATIONS: Record<string, Locale> = {
  fr: fr_FR,
  en: en_GB,
};

dayjs.locale(i18n.language);
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(utc);
dayjs.extend(localeData);
dayjs.extend(minMax);

export default function App() {
  return (
    <ApolloProvider client={clientNeoAuth}>
      <I18nextProvider i18n={i18n}>
        <ConfigProvider
          locale={CONFIG_TRANSLATIONS[i18n.language]}
          theme={{
            token: {
              colorPrimary: "#508a7e",
              colorText: "rgba(0, 0, 0, 0.65)",
              colorWarning: "#ffa500",
              // antd sets `font-family` on each component from this token, which
              // otherwise defaults to the system font stack and overrides the
              // Satoshi body font from neonumy-ui — same value as neonumy-ui's
              // own ThemeProvider.
              fontFamily: "Satoshi, sans-serif",
            },
            components: {
              Layout: {
                headerBg: "#508a7e",
                headerColor: "#fff",
                triggerBg: "#fff",
                triggerColor: "#508a7e",
              },
              Table: {
                headerBg: "#508a7e",
                headerColor: "#fff",
                headerSortActiveBg: "rgba(80, 138, 126, 0.6)",
              },
            },
          }}
        >
          <NotificationProvider>
            <RouterProvider router={routers} />
          </NotificationProvider>
        </ConfigProvider>
      </I18nextProvider>
    </ApolloProvider>
  );
}
